import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Router} from '@angular/router';
import {Constants} from '../../constants';
import {MatDialog} from '@angular/material';
import {ResultDialogComponent} from '../result-dialog/result-dialog.component';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  animations: [fadeAnimation]
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  hasError = false;
  errorMessage = "";

  constructor(private _fb: FormBuilder,
              private _http: Http,
              private _router: Router,
              private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.forgotPasswordForm = this._fb.group(
      {Email: new FormControl('', Validators.required)});
  }

  onSubmit() {
    let formData: string;
    formData = JSON.stringify(this.forgotPasswordForm.value);
    console.log(formData);
    const registrationUrl = Constants.NEXPRESS_ENDPOINT + 'Email/ForgotPassword';
    const headers = new Headers({
      'Content-Type': 'application/JSON'
    });
    const options = new RequestOptions({headers: headers});
    this._http.post(registrationUrl, formData, options)
      .map((response) => response.json())
      .subscribe(
        result => {
          // this._router.navigateByUrl('/checkemail');
          this.hasError = false;
          let dialogRef = this._dialog.open(ResultDialogComponent, {
            data: {
              title: 'Please Check Your Email',
              message: 'If your Nexpress account is associated with this address you will receive an email with a link to reset your password. If you do not see new mail within the next few minutes, please check your junk mail.',
              alertType: 'primary'
            }
          });
        },
        error => {
          let body = JSON.parse(error._body) || '';
          this.hasError = true;
          this.errorMessage = body.Message;
        }
      );
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/forgot-password/forgot-password.component.ts